var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"station-5 partBox"},[_c('MyTitle',{staticClass:"flexs",attrs:{"title":"日运营业务收入","type":"2"}}),_c('div',{staticClass:"box-content flex1 flex"},[(_vm.operatingRevenueShow)?_c('MyEchart',{attrs:{"id":'operatingRevenue',"options":_vm.operatingRevenueOptions}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }